import { createStore } from 'vuex'

import Notification from './notification'
import Session from './session'
import UnreadTickets from './unread-tickets'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Notification,
    Session,
    UnreadTickets
  }
})
